import React from 'react';
import './App.scss';
import Router from '../Router';

const App = () => {
  return (
    <div className="App">
      <Router />
    </div>
  );
};

export default App;
